import * as React from 'react';

function TestReactComponent(){
    return <div style={{ paddingTop:"150px" }}>
        <h1>Hello from React</h1>
    </div>
}

export default TestReactComponent;